var _radialGradient, _path, _radialGradient2, _path2, _path3, _circle, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramsvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "yOrnnhliCrdS2gy~4tD8ma",
    cx: 19.38,
    cy: 42.035,
    r: 44.899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fd5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#ff543f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.348,
    stopColor: "#fc5245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504,
    stopColor: "#e64771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.643,
    stopColor: "#d53e91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761,
    stopColor: "#cc39a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.841,
    stopColor: "#c837ab"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#yOrnnhliCrdS2gy~4tD8ma)",
    d: "M34.017,41.99l-20,0.019c-4.4,0.004-8.003-3.592-8.008-7.992l-0.019-20 c-0.004-4.4,3.592-8.003,7.992-8.008l20-0.019c4.4-0.004,8.003,3.592,8.008,7.992l0.019,20 C42.014,38.383,38.417,41.986,34.017,41.99z"
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "yOrnnhliCrdS2gy~4tD8mb",
    cx: 11.786,
    cy: 5.54,
    r: 29.813,
    gradientTransform: "matrix(1 0 0 .6663 0 1.849)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4168c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#4168c9",
    stopOpacity: 0
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#yOrnnhliCrdS2gy~4tD8mb)",
    d: "M34.017,41.99l-20,0.019c-4.4,0.004-8.003-3.592-8.008-7.992l-0.019-20 c-0.004-4.4,3.592-8.003,7.992-8.008l20-0.019c4.4-0.004,8.003,3.592,8.008,7.992l0.019,20 C42.014,38.383,38.417,41.986,34.017,41.99z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24,31c-3.859,0-7-3.14-7-7s3.141-7,7-7s7,3.14,7,7S27.859,31,24,31z M24,19c-2.757,0-5,2.243-5,5 s2.243,5,5,5s5-2.243,5-5S26.757,19,24,19z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 16.5,
    r: 1.5,
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30,37H18c-3.859,0-7-3.14-7-7V18c0-3.86,3.141-7,7-7h12c3.859,0,7,3.14,7,7v12 C37,33.86,33.859,37,30,37z M18,13c-2.757,0-5,2.243-5,5v12c0,2.757,2.243,5,5,5h12c2.757,0,5-2.243,5-5V18c0-2.757-2.243-5-5-5H18z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramsvg);
export default __webpack_public_path__ + "static/media/instagramsvg.e9d6b5424508db6397a027a4e0fe0dd0.svg";
export { ForwardRef as ReactComponent };